module.exports = __webpack_public_path__ + "img/Mudas infectadas por Neonectria ditissima oriundas do viveiro 3.63e3ea12.webp";